import { Component, Input, OnInit } from '@angular/core';
import { ElementTypeCategoriesDto } from '@cloud-twin-v2/generated/simulation.generated.client';
import { MapStep } from '@common-modules/wlm-map/models/map-step';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Observable, Subscription } from 'rxjs';
import { MasterOperatorConnectItemsSettings } from '../models/master-operator-connect-settings';

@UntilDestroy()
@Component({
    selector: 'tc-master-operator-map-buttons',
    templateUrl: './master-operator-map-buttons.component.html',
    styleUrls: ['./master-operator-map-buttons.component.scss'],
    standalone: false
})
export class MasterOperatorMapButtonsComponent implements OnInit {
  @Input() connectSettings: MasterOperatorConnectItemsSettings;
  @Input() attributesMetadata: Map<string, ElementTypeCategoriesDto[]>;
  @Input() step: MapStep;

  private _stepChanged$: Observable<MapStep>;
  public get stepChanged$(): Observable<MapStep> {
    return this._stepChanged$;
  }
  public set stepChanged$(value: Observable<MapStep>) {
    this._stepChanged$ = value;
    this._stepChangedSubscription?.unsubscribe();

    this._stepChangedSubscription = this._stepChanged$?.subscribe(
      (mapStep) => (this.step = mapStep)
    );
  }

  private _connectSettingsChanged$: Observable<MasterOperatorConnectItemsSettings>;
  public get connectSettingsChanged$(): Observable<MasterOperatorConnectItemsSettings> {
    return this._connectSettingsChanged$;
  }
  public set connectSettingsChanged$(value: Observable<MasterOperatorConnectItemsSettings>) {
    this._connectSettingsChanged$ = value;
    this._connectSettingsChangedSubscription?.unsubscribe();
    this._connectSettingsChangedSubscription = this._connectSettingsChanged$?.subscribe(
      (connectSettings) => (this.connectSettings = connectSettings)
    );
  }

  private _attributesMetadataChanged$: Observable<Map<string, ElementTypeCategoriesDto[]>>;
  public get attributesMetadataChanged$(): Observable<Map<string, ElementTypeCategoriesDto[]>> {
    return this._attributesMetadataChanged$;
  }
  public set attributesMetadataChanged$(
    value: Observable<Map<string, ElementTypeCategoriesDto[]>>
  ) {
    this._attributesMetadataChanged$ = value;
    this._attributesMetadataChangedSubscription?.unsubscribe();
    this._attributesMetadataChangedSubscription = this._attributesMetadataChanged$?.subscribe(
      (metaData) => (this.attributesMetadata = metaData)
    );
  }

  private _params: any;
  public get params(): any {
    return this._params;
  }
  public set params(v: any) {
    this._params = v;
    if (v) {
      this.setSettings(v);
    }
  }

  private _stepChangedSubscription: Subscription;
  private _attributesMetadataChangedSubscription: Subscription;
  private _connectSettingsChangedSubscription: Subscription;

  constructor() {}

  ngOnInit(): void {
    console.log('connectSettings', this.connectSettings);
  }

  private setSettings(params: any) {
    this.connectSettingsChanged$ = params.connectSettingsChanged$;
    this.attributesMetadataChanged$ = params.attributesMetadataChanged$;
    this.stepChanged$ = params.stepChanged$;
  }
}
